import * as Constants from '../../utils/constants';

export const getFavoriteData = (data: any, isHideLoader= false) => {
    return ({
        type: Constants.FAVORITE_LOADS_DATA,
        payload: { data, isHideLoader }
    })
}

export const updateFavoriteData = (data: any, isHideLoader = false) => {
    return ({
        type: Constants.UPDATE_FAVORITE_LOADS,
        payload: {data, isHideLoader}
    })
}

export const updateFavoriteDataReducer = (data: any) => ({
    type: Constants.UPDATE_FAVORITE_LOADS_REDUCER,
    payload: data
})

// action to check the duplicate or list full error while adding to favorite list
export const updateFavoriteError = (data:any) => ({
    type: Constants.UPDATE_FAVORITE_ERROR,
    payload: data.data
})

export const getFavorite = (data: any) =>({
        type: Constants.GET_FAVORITE,
        payload: data
})

export const clearUpdatedId = (data: any) => ({
    type: Constants.CLEAR_UPDATE_FAVORITE_LOADS_ID,
    payload: data
})
